import { httpClient } from "./client";
import type { SecurityObjectPermission } from "../types/security";

export const HttpSecurityObjects = {
    getEndpoint: (url: string = "") => `/objetos-seguridad${url}`,

    getAll: (): Promise<SecurityObjectPermission[]> =>
        httpClient.get<SecurityObjectPermission[]>(HttpSecurityObjects.getEndpoint()),
};
